<template>
  <modal height="auto" :width="width" name="login-modal" transition="pop-out" @closed="beforeClose">
    <div class="login-modal">
      <div class="login-modal__logo">
        <img src="../assets/img/ismailaga-logo.png" alt="">
      </div>
      <div
        v-if="isRegister && !isForget"
        :key="'register'"
        class="close__button"
        @click="isRegister = false"
      >
        <i class="fas fa-arrow-left"></i>
      </div>
      <div v-if="isForget" :key="'register'" class="close__button" @click="isForget = false">
        <i class="fas fa-arrow-left"></i>
      </div>
      <div
        v-if="isConfirmation"
        :key="'confirmation'"
        class="close__button"
        @click="isConfirmation = false"
      >
        <i class="fas fa-arrow-left"></i>
      </div>
      <div
        v-if="!isRegister && !isForget"
        class="close__button"
        :key="'login'"
        @click="$modal.hide('login-modal')"
      >X</div>

      <div class="login-modal__title">
        <p v-show="!isRegister && !isForget && !isConfirmation">GİRİŞ YAP</p>
        <p v-show="isForget && !isConfirmation">ŞİFRE HATIRLATMA</p>
        <p v-show="isRegister">YENİ KAYIT</p>
        <p v-show="isConfirmation">ONAY KODU</p>
      </div>
      <div class="d-flex align-items-center w-100" v-if="!isConfirmation">
        <multiselect
          v-model="country_phone_code"
          :options="phoneCountryCodesObj"
          class="rounded-0 mr-3"
          :multiple="false"
          :close-on-select="true"
          :hide-selected="false"
          :preserve-search="true"
          selectedLabel
          select-label
          deselectLabel
          placeholder
          label="label"
          :show-labels="false"
          track-by="name"
        >
          <template slot="singleLabel" slot-scope="props">
            +{{ props.option.name }}
          </template>
        </multiselect>
        <input
          type="text"
          v-model="phone"
          v-if="country_phone_code.name != 90"
          class="mb-4 mt-4 login-modal__input"
        >
        <the-mask
          v-if="country_phone_code.name == 90"
          :mask="['(###) ### ## ##']"
          placeholder="Cep Telefonu"
          v-model="phone"
          required
          class="mb-4 mt-4 login-modal__input"
        />
      </div>
      <div class="w-100">
        <input
          v-show="isRegister"
          class="mb-4 login-modal__input"
          type="email"
          v-model="email"
          placeholder="E-posta"
          required
        />
      </div>
      <div class="d-flex w-100">
        <input
          v-show="isRegister"
          class="mb-4 mr-1 login-modal__input"
          type="text"
          v-model="name"
          placeholder="İsim"
          required
        />
        <input
          v-show="isRegister"
          class="mb-4 ml-1 login-modal__input"
          type="text"
          v-model="surname"
          placeholder="Soyisim"
          required
        />
      </div>
      <!-- CONFIRMATION CODE -->
      <div class="w-100" v-show="isConfirmation">
        <input
          class="mb-4 login-modal__input"
          type="mail"
          v-model="confirmationCode"
          placeholder="Onay Kodu Giriniz"
        />
        <input
          class="mb-4 login-modal__input"
          type="password"
          v-model="password"
          placeholder="Şifre"
        />
        <input
          class="mb-4 login-modal__input"
          type="password"
          v-model="rePassword"
          placeholder="Şifre Tekrar"
        />
      </div>
      <div class="w-100 login-modal__phone-wrapper" v-show="!isForget">
        <input
          class="mb-4 login-modal__input"
          type="password"
          v-model="password"
          placeholder="Şifre"
          @keyup.enter="handleLogin"
          required
        />
        <i class="fas fa-eye icon"></i>
      </div>
      <div v-show="isRegister  && !isForget" class="w-100 login-modal__phone-wrapper">
        <input
          class="mb-4 login-modal__input"
          type="password"
          v-model="rePassword"
          placeholder="Şifre Tekrar"
          required
        />
        <i class="fas fa-eye icon"></i>
      </div>
      <a
        v-show="!isRegister && !isForget"
        class="login-modal__forget-link"
        @click="isForget = true"
      >ŞİFREMİ HATIRLAT</a>

      <!-- BUTTONS -->
      <button
        v-show="!isRegister && !isForget"
        class="button button__red login-modal__button w-100"
        @click="handleLogin"
      >GİRİŞ YAP</button>

      <button
        v-show="!isRegister && !isForget"
        @click="isRegister = true"
        class="button login-modal__new-account w-100 mt-4"
      >YENİ HESAP OLUŞTUR</button>
      <button
        v-if="isRegister"
        class="button button__red login-modal__button w-100 mt-4"
        @click="handleRegister"
      >ŞİMDİ KAYIT OL</button>
      <button
        v-show="isConfirmation"
        class="button button__red login-modal__button w-100 mt-4"
        @click="resetPassword"
      >ŞİFREMİ KAYDET VE GİRİŞ YAP</button>
      <button
        v-show="isForget && !isConfirmation"
        class="button button__red login-modal__button w-100 mt-4"
        @click="handleForget"
      >ŞİFRE SIFIRLAMA KODU GÖNDER</button>
    </div>
  </modal>
</template>

<script>
import { mapActions } from 'vuex'
import { TheMask } from 'vue-the-mask'
import Swal from 'sweetalert2'
import Multiselect from 'vue-multiselect'

export default {
  props: {
    show: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      name: '',
      phone: '',
      email: '',
      width: 450,
      surname: '',
      password: '',
      rePassword: '',
      isForget: false,
      isRegister: false,
      confirmationCode: '',
      isConfirmation: false,
      phoneCountryCodesObj: [],
      country_phone_code: {
        id: '+90',
        name: '90',
        label: '+90'
      }
    }
  },
  components: {
    TheMask,
    Multiselect
  },
  methods: {
    ...mapActions(['login', 'register']),
    handleLogin() {
      this.login({
        phone_number: this.phone,
        country_phone_code: this.country_phone_code.name,
        password: this.password
      })
        .then(() => {
          this.$modal.hide('login-modal')
        })
        .catch((err) => {
          let errors

          if (err.response.data.errors) {
            errors = Object.values(err.response.data.errors)
              .flatMap(item => item)
              .join('<br/>')
          } else if (err.response.data.message) {
            errors = err.response.data.message
          }

          Swal.fire({
            title: 'Lütfen bilgilerinizi kontrol edin!',
            html: errors,
            type: 'error',
            confirmButtonText: 'Tamam'
          })
        })
    },
    handleRegister() {
      if (this.password === this.rePassword) {
        this.register({
          phone_number: this.phone,
          country_phone_code: this.country_phone_code.name,
          password: this.password,
          password_confirmation: this.rePassword,
          first_name: this.name,
          surname: this.surname,
          email: this.email
        })
          .then(() => {
            this.$modal.hide('login-modal')
          })
          .catch((err) => {
            let errors

            if (err.response.data.errors) {
              errors = Object.values(err.response.data.errors)
                .flatMap(item => item)
                .join('<br/>')
            } else if (err.response.data.message) {
              errors = err.response.data.message
            }

            Swal.fire({
              title: 'Lütfen bilgilerinizi kontrol edin!',
              html: errors,
              type: 'error',
              confirmButtonText: 'Tamam'
            })
          })
      } else {
        Swal.fire({
          title: 'Şifre tekrarı eşleşmiyor.',
          type: 'error',
          confirmButtonText: 'Tamam'
        })
      }
    },
    handleForget() {
      this.$http
        .post('v2/user/forgot-password', {
          phone_number: this.phone,
          country_phone_code: this.country_phone_code.name
        })
        .then(() => {
          this.isConfirmation = true
        })
        .catch(() => {
          Swal.fire({
            title: 'Geçersiz telefon numarası.',
            type: 'error',
            confirmButtonText: 'Tamam'
          })
        })
    },
    resetPassword() {
      this.$http
        .post('v2/user/reset-password', {
          code: this.confirmationCode,
          country_phone_code: this.country_phone_code.name,
          phone_number: this.phone,
          password: this.password,
          password_confirmation: this.rePassword
        })
        .then(() => {
          this.login({
            phone_number: this.phone,
            country_phone_code: this.country_phone_code.name,
            password: this.password
          })
          this.$modal.hide('login-modal')
          Swal.fire({
            title: 'Şifreniz değiştrildi ve başarıyla giriş yaptınız.',
            type: 'success',
            confirmButtonText: 'Tamam'
          })
        })
        .catch((err) => {
          let errors

          if (err.response.data.errors) {
            errors = Object.values(err.response.data.errors)
              .flatMap(item => item)
              .join('<br/>')
          }

          Swal.fire({
            title: 'Lütfen bilgilerinizi kontrol edin!',
            html: errors,
            type: 'error',
            confirmButtonText: 'Tamam'
          })
        })
    },
    beforeClose() {
      this.name = ''
      this.phone = ''
      this.email = ''
      this.surname = ''
      this.password = ''
      this.rePassword = ''
      this.isForget = false
      this.isRegister = false
      this.confirmationCode = ''
      this.isConfirmation = false

      this.$store.dispatch('toggleLoginModal', {
        isOpen: false
      })
    }
  },
  created() {
    this.width = Math.min(window.innerWidth - 20, 500)
    this.loadCountries()
  },
  watch: {
    show(newVal) {
      if (newVal === true) this.$modal.show('login-modal')
      else this.$modal.hide('login-modal')
    }
  }
}
</script>
